export default __webpack_public_path__ + "static/media/jpeg.f97463d3.svg";